<template>
  <Teleport to="body">
    <Transition name="modal">
      <UseFocusTrap v-if="show" :options="{ immediate: true }">
        <div class="i-modal-mask" ref="modalRef" @keydown.escape.prevent.stop="close" tabindex="-1">
          <div class="i-modal-wrapper">
            <div class="i-modal-content-wrapper" role="dialog">
              <div
                class="i-modal-content"
                v-bind="$attrs"
                v-on-clickaway="closeOnClickAway && close"
              >
                <div class="i-modal-header">
                  <slot name="header">
                    <div class="flex justify-between">
                      <span class="title flex-auto">{{ title }}</span>
                      <i-button title="Close" class="i-button-close" @click.prevent="close">
                        <i-icon icon="times" size="medium"></i-icon>
                      </i-button>
                    </div>
                  </slot>
                </div>
                <div class="i-modal-body">
                  <slot />
                </div>
                <div class="i-modal-footer">
                  <slot name="footer">
                    <i-button variant="secondary" @click.prevent="close">Cancel</i-button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </UseFocusTrap>
    </Transition>
  </Teleport>
</template>

<script>
import { UseFocusTrap } from '@vueuse/integrations/useFocusTrap/component'
import Button from '@/components/lib/button/Button.vue'
import Icon from '@/components/lib/icon/Icon.vue'
import { directive as onClickaway } from 'vue3-click-away'

export default {
  name: 'i-modal',
  emits: ['update:show', 'openAutoFocus'],
  directives: {
    onClickaway
  },
  components: {
    UseFocusTrap,
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  props: {
    title: {
      type: String
    },
    show: {
      type: Boolean,
      default: false
    },
    closeOnClickAway: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show(value) {
      if (!value) return
      this.$nextTick(() => {
        const { modalRef } = this.$refs
        if (modalRef) {
          modalRef.focus()

          this.$emit('openAutoFocus')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.i-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.i-modal-wrapper {
  display: table-cell;
  vertical-align: top;
}

.i-modal-body {
  padding: 15px;
  max-height: 550px;
  overflow-y: auto;
}

.i-modal-content-wrapper {
  transition: all 0.3s ease;
  margin: 10px;
}

@media (min-width: 768px) {
  .i-modal-content-wrapper {
    margin: 30px 10px;
  }
}

.i-modal-content {
  max-width: 1100px;
  margin: 0px auto;
}

.i-modal-footer:deep(.i-button) {
  margin-right: 0;
  margin-bottom: 0;
  margin-top: 0px;
}

.i-modal-header {
  font-family: $font-family-regular;
  font-size: 18px;
  border: none;
  padding: 0px;
  .title {
    padding: 15px;
    text-transform: none;
  }
  .i-button-close {
    margin: 0;
    height: 35px;
    margin: 8px;
  }
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .i-modal-content-wrapper,
.modal-leave-to .i-modal-content-wrapper {
  transform: translateY(-50px);
}
</style>
